export const updateCollectorInfo = (payload) => ({
  //always caps
  type: "UPDATE",
  payload: payload,
});
